import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { AppProviders } from './AppProviders.jsx';
import './index.css';
import { TanStackDevtools } from '@tanstack/react-devtools';
import { appName } from './shared/lib/getAppName';

document.title = appName;

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: __APP_COMMIT__,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 0.1,
    // Attach sentry-trace/baggage headers to requests hitting our own backends only
    tracePropagationTargets: [/^https:\/\/.*\.aimaxvn\.com/],
    // Session Replay — masks all text/media by default (safe w/ financial/PII data in this app)
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
  });
}

// Version banner in browser console (hidden from regular users)
console.info(
  `%c FI Dashboard %c v${__APP_VERSION__} (${__APP_COMMIT__}) `,
  'background:#18181b;color:#a3e635;font-weight:bold;padding:2px 4px',
  'background:#27272a;color:#a1a1aa;padding:2px 4px',
);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AppProviders />
    <TanStackDevtools />
  </StrictMode>
);
